export const CONSENT_STORAGE_KEY = 'shopquay_cookie_notice_v1'
export const CONSENT_EVENT = 'shopquay-cookie-consent'

export type CookieConsent = 'accepted' | 'essential'
